<ng-container *ngIf="_showItems">
    <div class="show font-5 font-weight-bold uppercase" [ngClass]="{'mobile': mobile}">
        <span>Show:</span>
        <div class="show__container">
        <span *ngIf="selectedShow" [class.is-active-dropdown]="showActive" class="show__trigger font-2" (click)="toggleShow()">
                <span class="sort__trigger--label">
                {{ selectedShow.label }}
            </span>
        </span>
        <span class="show__dropdown"  [class.active]="showActive" [class.left]="position === 'left'" [class.right]="position === 'right'">
          <label *ngFor="let item of _showItems" class="products-list__filters__parent custom-control custom-radio font-5">
              <input value="{{ item.name }}" name="show" class="custom-control-input radio-dark-gray" type="radio"
                     (change)="updateSelected(item)" [checked]="item.selected">
              <span class="custom-control-indicator"></span>
              <span class="custom-control-description">{{ item.label }}</span>
          </label>
        </span>
        </div>
        <div class="ml-3" *ngIf="canShowExport">
<!--            <button class="btn btn-icon large with-border with-shadow background-white mr-2" title="Export to Excel" (click)="exportToExcel()"><i class="fal fa-file-excel"></i></button>-->
<!--            <button class="btn btn-icon large with-border with-shadow background-white" title="Export to PDF" (click)="exportToPDF()"><i class="fal fa-file-pdf"></i></button>-->
        </div>
    </div>
</ng-container>
